<template>
  <div>
    <div v-if="layout=='grid'">
      <v-container fluid class="ma-4 ml-6">
        <v-row>
          <v-card v-for="(item, index) in table.items" :key="index" class="ma-2">
            <v-card-title class="subtitle-1 pa-2 blue-grey white--text">{{item.label}}</v-card-title>
            <v-card-text class="pa-4">
              <table class="stb-config-vcard">
                <tr v-for="(header, hi) in tableGridFields" :key="hi">
                  <td>
                    <h4>{{header.text}}:</h4>
                  </td>
                  <td>{{item[header.value]}}</td>
                </tr>
              </table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    small
                    color="blue"
                    class="ma-auto"
                    @click="editorOpen(item.id, 'summary')"
                  >
                    <v-icon>mdi-square-edit-outline</v-icon>
                  </v-btn>
                </template>
                <span>Edit configuration summary</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    small
                    color="blue"
                    class="ma-auto"
                    @click="editorOpen(item.id, 'properties')"
                  >
                    <v-icon>mdi-playlist-edit</v-icon>
                  </v-btn>
                </template>
                <span>Edit configuration properties</span>
              </v-tooltip>
              <v-tooltip top v-if="isManageableItem(item)">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    small
                    color="blue"
                    class="ma-auto"
                    @click="editorOpen(item.id, 'delegations')"
                  >
                    <v-icon>mdi-account-group-outline</v-icon>
                  </v-btn>
                </template>
                <span>Edit configuration delegations</span>
              </v-tooltip>
            </v-card-actions>
          </v-card>
        </v-row>
      </v-container>
    </div>
    <div v-if="layout=='list'" class="full-height">
      <v-card class="ma-2">
        <v-card-text>
          <v-container fluid class="pa-0 ma-0">
            <v-row class="pa-0 mx-2 my-0">
              <v-col class="pa-0 ma-0">
                <v-text-field
                  class="ma-0"
                  v-model="table.search"
                  append-icon="mdi-filter"
                  label="Filter table entries"
                  single-line
                  hide-details
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="auto" class="pa-0 ma-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      @click="selectUpdateSetup()"
                      :disabled="selectUpdateActionDisabled"
                      large
                      class="my-2 mx-0"
                    >
                      <v-icon class="ma-0">mdi-pencil-box-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit the selected configurations</span>
                </v-tooltip>
              </v-col>
              <v-col cols="auto" class="pa-0 ma-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="load()" large class="my-2 mx-0">
                      <v-icon class="ma-0">mdi-reload</v-icon>
                    </v-btn>
                  </template>
                  <span>Reload configuration table</span>
                </v-tooltip>
              </v-col>
              <v-col cols="auto" class="pa-0 ma-0">
                <v-menu v-model="settingsMenu" :close-on-content-click="false" offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" large class="my-2">
                      <v-icon>mdi-table-settings</v-icon>
                    </v-btn>
                  </template>
                  <v-card min-width="320px">
                    <v-list>
                      <v-list-item>
                        <v-list-item-title>Display the table columns:</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-for="(item, index) in displayColumns.items" :key="index">
                        <v-list-item-action>
                          <v-switch v-model="displayColumns.value[item.value]"></v-switch>
                        </v-list-item-action>
                        <v-list-item-title>{{item.text}}</v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-title>Editor dialog box:</v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-action>
                          <v-switch v-model="editor.persistent"></v-switch>
                        </v-list-item-action>
                        <v-list-item-title>Persistent mode</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-container fluid class>
          <v-data-table
            :headers="table.headers"
            :items="table.items"
            class="elevation-1"
            item-key="id"
            v-model="table.selected"
            multi-sort
            filterable
            show-select
            :options.sync="table.options"
            :search="table.search"
            :loading="table.loading"
          >
            <template v-slot:item.action="{ item }">
              <span class="actions">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      small
                      class="ma-auto"
                      @click="editorOpen(item.id, 'summary')"
                    >
                      <v-icon>mdi-square-edit-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit configuration summary</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      small
                      class="ma-auto"
                      @click="editorOpen(item.id, 'properties')"
                    >
                      <v-icon>mdi-playlist-edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit configuration properties</span>
                </v-tooltip>
                <v-tooltip top v-if="isManageableItem(item)">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      small
                      class="ma-auto"
                      @click="editorOpen(item.id, 'delegations')"
                    >
                      <v-icon>mdi-account-group-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit configuration delegations</span>
                </v-tooltip>
              </span>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </div>
    <v-dialog v-model="selectUpdate.enabled" max-width="512" persistent>
      <v-card>
        <v-card-title class="headline">Update selection</v-card-title>
        <v-window v-model="selectUpdate.tabIndex">
          <v-window-item>
            <v-card-text>
              <v-row class="fill-height ma-0 pa-2 pb-8" align-content="center" justify="center">
                <v-col
                  class="subtitle-1 text-left"
                  cols="auto"
                >You're about to update the {{selectUpdate.count}} selected configuration(s) with the following properties:</v-col>
                <v-col cols="auto">
                  <table class="stb-config-vcard">
                    <tr v-for="(item, i) in selectUpdate.displayList" v-bind:key="i">
                      <td>
                        <h4>{{item.label}}:</h4>
                      </td>
                      <td>{{item.value}}</td>
                    </tr>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success white--text" @click="selectUpdateConfirm()">
                <v-icon>mdi-check-circle-outline</v-icon>Confirm
              </v-btn>
              <v-btn color="orange white--text" @click="selectUpdateClose()">
                <v-icon>mdi-cancel</v-icon>Cancel
              </v-btn>
            </v-card-actions>
          </v-window-item>
          <v-window-item>
            <v-row class="fill-height ma-0 pa-2 pb-8" align-content="center" justify="center">
              <v-col class="subtitle-1 text-center" cols="12">Processing configurations</v-col>
              <v-col cols="6">
                <v-progress-linear indeterminate rounded height="6"></v-progress-linear>
              </v-col>
            </v-row>
          </v-window-item>
          <v-window-item>
            <v-card-text>
              <p>Configuration process terminated:</p>
              <v-list shaped class="update-results">
                <v-list-item v-for="(item, i) in selectUpdate.results" :key="i">
                  <v-list-item-icon>
                    <v-icon :color="item.color" v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>{{item.text}}</v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="orange white--text" @click="selectUpdateClose()">
                <v-icon>mdi-close</v-icon>Close
              </v-btn>
            </v-card-actions>
          </v-window-item>
        </v-window>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editor.active" width="unset" :persistent="editor.persistent">
      <STBConfig
        :id="editor.id"
        :tab="editor.tab"
        :prefillProductVersion="editor.prefillProductVersion"
        @close="editorClose"
        @error="processErrorResponse"
        @success="displaySuccess"
      ></STBConfig>
    </v-dialog>
  </div>
</template>

<style scoped>
table.stb-config-vcard > tr > td:first-child > h4 {
  white-space: nowrap;
  padding-right: 5px;
  text-align: right;
}
span.actions {
  white-space: nowrap;
}
.v-list.update-results {
  height: 256px;
  overflow-y: auto;
}
</style>

<script>
import STBConfig from "../components/STBConfig.vue";

import {
  getOperatorTitle,
  getLocalParam,
  setLocalParam,
  makeMovableDialogs,
  tryJSONParse,
  getConfigPropertyTitle,
  checkNested
} from "./../lib";

makeMovableDialogs();

export default {
  name: "STBConfigList",
  components: { STBConfig },
  props: {
    layout: {
      type: String,
      default: "list",
      validator: value => ["list", "grid"].indexOf(value) !== -1
    },
    listType: {
      default: "user",
      type: String
    },
    tags: {
      default: "[]",
      type: String
    },
    id: {
      default: "",
      type: String
    }
  },
  data: () => ({
    editor: {
      id: null,
      tab: null,
      active: false,
      prefillProductVersion: null,
      persistent: getLocalParam("settings.configList.editor.persistent", true)
    },
    displayColumns: {
      items: [
        { text: "MAC", value: "mac" },
        { text: "Product", value: "productVersion" },
        { text: "Operator", value: "operator" },
        { text: "Application", value: "appli" },
        { text: "User interface", value: "ui" },
        { text: "Recovery", value: "bsl" },
        { text: "Data", value: "data" },
        { text: "Owner", value: "owner" },
        { text: "Usage type", value: "usageType" }
      ],
      value: getLocalParam("settings.configList.table.columns", {
        mac: true,
        productVersion: true,
        operator: false,
        appli: true,
        ui: true,
        bsl: true,
        data: false,
        owner: true,
        usageType: false
      })
    },
    settingsMenu: false,
    table: {
      configList: [],
      selected: [],
      items: [],
      options: null,
      loading: false,
      search: "",
      index: -1,
      headers: [
        { text: "Label", align: "left", sortable: true, value: "label" },
        { text: "Actions", align: "left", value: "action", sortable: false },
        { text: "MAC", align: "left", sortable: true, value: "mac" },
        {
          text: "Product",
          align: "left",
          sortable: true,
          value: "productVersion"
        },
        { text: "Operator", align: "left", sortable: true, value: "operator" },
        { text: "Application", align: "left", sortable: true, value: "appli" },
        { text: "User interface", align: "left", sortable: true, value: "ui" },
        { text: "Recovery", align: "left", sortable: true, value: "bsl" },
        { text: "Data", align: "left", sortable: true, value: "data" },
        { text: "Owner", align: "left", sortable: true, value: "owner" },
        {
          text: "Usage type",
          align: "left",
          sortable: true,
          value: "usageType"
        }
      ]
    },
    selectUpdate: {
      result: [],
      data: {},
      enabled: false,
      count: 0,
      tabIndex: 0
    }
  }),
  computed: {
    selectUpdateActionDisabled() {
      return !this.table.selected.length;
    },
    tableGridFields() {
      return this.table.headers.filter(e => e.value !== "action");
    }
  },
  watch: {
    id(value) {
      if (value) this.editorOpen(value);
    },
    tags(value) {
      if (value) this.onTagsChange();
    },
    layout(value) {
      setLocalParam("settings.configList.layout", value);
    },
    "editor.persistent": function(value) {
      setLocalParam("settings.configList.editor.persistent", value);
    },
    listType(value) {
      setLocalParam("settings.configList.listType", value);
      this.load();
    },
    "table.search": function() {
      this.table.selected = [];
    },
    "table.options": {
      deep: true,
      handler(options) {
        setLocalParam("settings.configList.table", options);
      }
    },
    "displayColumns.value": {
      deep: true,
      handler(options) {
        setLocalParam("settings.configList.table.columns", options);
        this.refreshDisplayColumns();
      }
    }
  },
  created() {
    this.table.options = getLocalParam("settings.configList.table", {
      multiSort: true,
      mustSort: false
    });
    this.refreshDisplayColumns();
    this.load();
    if (this.id) {
      this.editorOpen(this.id);
    }
  },
  methods: {
    processErrorResponse(result) {
      this.$emit("error", result);
    },
    refreshDisplayColumns() {
      this.table.headers.forEach(e => {
        if (!e.alignOrig) {
          e.alignOrig = e.align || "left";
        }
        if (this.displayColumns.value[e.value] === false) {
          e.align = "left d-none";
        } else {
          e.align = e.alignOrig;
        }
      });
    },
    displaySuccess(result) {
      this.$emit("success", result);
    },
    isManageableItem(item) {
      return (
        this.$store.getters.userIsAdmin ||
        this.$store.getters.userId === item.ownerId
      );
    },
    onTagsChange() {
      var tagList = tryJSONParse(this.tags, []);
      this.table.items = this.table.configList.filter(elt =>
        tagList.every(r => elt.tags.includes(r))
      );
      this.table.selected = [];
    },
    load() {
      this.table.loading = true;
      this.$axios
        .get(
          `/configs?limit=65536&extended_format=true&global=${this.listType ==
            "global"}`
        )
        .then(result => {
          this.configTagResetList();
          this.table.configList = result.data.map(elt => {
            var props = elt.properties || {};
            if (!props.x_display_titles) {
              props.x_display_titles = {};
            }
            const tagList = props.x_tags || [];
            if (props.x_product_version) {
              tagList.push(props.x_product_version);
            }
            const usageType = props.x_usage_type || "Development";
            tagList.push(usageType);
            this.configTagAdd(tagList);
            return {
              id: elt.set_top_box_id,
              label: elt.label || props.x_product_version || "STB",
              mac: elt.set_top_box_id.match(/.{2}/g).join(":"),
              owner: props.x_display_titles[elt.owner_id] || elt.owner_id,
              ownerId: elt.owner_id,
              productVersion: props.x_product_version || "",
              usageType: usageType,
              operator: getOperatorTitle(props.x_operator) || "",
              appli: props.x_display_titles[props.appli] || props.appli || "",
              ui: props.x_display_titles[props.ui] || props.ui || "",
              bsl: props.x_display_titles[props.bsl] || props.bsl || "",
              data: props.x_display_titles[props.data] || props.data || "",
              tags: tagList
            };
          });
          this.table.loading = false;
          this.onTagsChange();
        })
        .catch(result => {
          this.processErrorResponse(result);
          this.table.loading = false;
        });
    },
    selectUpdateSetup() {
      if (this.editor.active) return;
      this.editor.tab = "summary";
      const pv = this.table.selected[0].productVersion;
      if (this.table.selected.every(e => e.productVersion === pv)) {
        this.editor.prefillProductVersion = pv;
      } else {
        this.editor.prefillProductVersion = null;
      }
      this.editor.id = null;
      this.editor.active = true;
    },
    selectUpdateConfirm() {
      this.selectUpdate.tabIndex = 1;
      this.$axios
        .get(
          `/configs?limit=65536&extended_format=true&global=${this.listType ==
            "global"}`
        )
        .then(result => {
          var configHashMap = {};
          this.selectUpdate.results = [];
          result.data.forEach(
            elt => (configHashMap[elt.set_top_box_id] = elt || {})
          );
          this.table.selected.forEach(item => {
            const config = configHashMap[item.id];
            if (!config) {
              this.selectUpdate.results.push({
                icon: "mdi-alert-circle-outline",
                text: `${item.id}: Configuration not found!`,
                color: "red white--text"
              });
              return;
            }
            const properties = config.properties;
            const updateData = this.selectUpdate.data;
            if (!properties.x_display_titles) {
              properties.x_display_titles = {};
            }
            var titles = properties.x_display_titles;
            var newProperties = {};
            var newConfig = {
              set_properties: newProperties
            };
            if (updateData.usageType) {
              newProperties.x_usage_type = updateData.usageType;
            }
            if (updateData.owner) {
              delete titles[config.owner_id];
              titles[updateData.owner.value] = updateData.owner.text;
              newConfig.owner_id = updateData.owner.value;
            }
            if (
              updateData.tags.length ||
              updateData.tagOperationType === "set"
            ) {
              switch (updateData.tagOperationType) {
                case "set":
                  newProperties.x_tags = updateData.tags;
                  break;
                case "add":
                  newProperties.x_tags = [
                    ...new Set(
                      (properties.x_tags || []).concat(updateData.tags)
                    )
                  ];
                  break;
              }
            }
            this.selectUpdate.data.properties.forEach(prop => {
              // Remove old title
              if (properties[prop.name]) delete titles[properties[prop.name]];
              // Set the new values
              newProperties[prop.name] = prop.data.value;
              titles[prop.data.value] = prop.data.text;
            });
            // append updated title hash
            newProperties.x_display_titles = titles;
            this.$axios
              .put("/configs/" + item.id, newConfig)
              .then(() => {
                this.selectUpdate.results.push({
                  icon: "mdi-checkbox-marked-circle-outline",
                  text: `Config [${item.id.match(/.{2}/g).join(":")}]`,
                  color: "success white--text"
                });
                if (
                  this.selectUpdate.results.length ===
                  this.table.selected.length
                ) {
                  this.load();
                  this.selectUpdate.tabIndex = 2;
                }
              })
              .catch(result =>
                this.selectUpdate.results.push({
                  icon: "mdi-alert-circle-outline",
                  text:
                    `Config [${item.id.match(/.{2}/g).join(":")}]: ` +
                    (() => {
                      if (
                        checkNested(
                          result,
                          "response",
                          "data",
                          "error",
                          "message"
                        )
                      ) {
                        return result.response.data.error.message;
                      } else if (checkNested(result, "message")) {
                        return result.message;
                      } else {
                        return result;
                      }
                    })(),
                  color: "red white--text"
                })
              );
          });
        })
        .catch(result => {
          this.processErrorResponse(result);
          this.selectUpdate.enabled = false;
        });
    },
    selectUpdateClose() {
      this.selectUpdate.enabled = false;
    },
    editorOpen(id, tab) {
      if (this.editor.active) return;
      this.editor.active = true;
      this.editor.id = id;
      this.editor.tab = tab;
      this.editor.prefillProductVersion = null;
      this.table.index = this.table.configList.findIndex(
        e => e.id === this.editor.id
      );
      if (this.table.index === -1) {
        this.table.index = this.table.configList.length;
        this.table.configList.push({
          id: this.editor.id,
          label: "STB",
          mac: this.editor.id.match(/.{2}/g).join(":")
        });
      }
    },
    editorClose(result) {
      this.editor.active = false;
      this.editor.tab = null;
      if (!result) return;
      const index = this.table.index;
      this.table.index = -1;
      switch (result.type) {
        case "update":
          if (index < 0) return;
          this.table.configList.splice(index, 1);
          this.table.configList.splice(index, 0, result.data);
          break;
        case "delete":
          if (index < 0) return;
          this.table.configList.splice(index, 1);
          break;
        case "updateSelection":
          this.selectUpdate.data = result.data;
          this.selectUpdate.displayList = [];
          if (result.data.usageType) {
            this.selectUpdate.displayList.push({
              label: "Usage type",
              value: result.data.usageType
            });
          }
          if (result.data.owner) {
            this.selectUpdate.displayList.push({
              label: "Owner",
              value: result.data.owner.text
            });
          }
          if (
            result.data.tags.length ||
            result.data.tagOperationType === "set"
          ) {
            this.selectUpdate.displayList.push({
              label: `Tag list (${result.data.tagOperationType})`,
              value: result.data.tags.join(", ")
            });
          }
          result.data.properties.forEach(item => {
            this.selectUpdate.displayList.push({
              label: getConfigPropertyTitle(item.name),
              value: item.data.text
            });
          });
          this.selectUpdate.tabIndex = 0;
          this.selectUpdate.enabled = true;
          this.selectUpdate.count = this.table.selected.length;
          return;
      }
      this.onTagsChange();
    },
    configTagResetList() {
      this.$store.commit("config_tag_list_reset");
    },
    configTagAdd(value) {
      this.$store.commit("config_tag_add", value);
    },
    getConfigPropertyTitle(value) {
      return getConfigPropertyTitle(value);
    }
  }
};
</script>
